import { Container, Theme, Typography } from "@material-ui/core";
import React, { ReactElement, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            border: `solid 1px ${palette.divider}`,
            padding: spacing(1),
        },
    }),
);

interface PostMessageData {
    message: {
        type: string;
    };
}

export default function TestAlmePostMessageListener(): ReactElement {
    const classes = useStyles();

    const [postMessageValue, setPostMessageValue] = useState<string>("No post messages received");

    const handleMinimizeClose = (e: MessageEvent): void => {
        const data = e.data as PostMessageData;
        setPostMessageValue(data?.message?.type ?? "Post message received but incorrect type");
    };

    window.addEventListener('message', handleMinimizeClose);

    return (
        <Container className={classes.root}>
            <Typography variant='subtitle1'>PostMessage Listener</Typography>
            <textarea value={postMessageValue} readOnly={true}/>
        </Container>
    );
}